import { Injectable, EventEmitter } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';

import { BaseAuthService } from "./base-auth.service";
import { PublicService } from "./public.service";

import { Page } from "./models/page";
import { PagedData } from "./models/paged-data";
import { ServerResponse } from "./models/server-response.model";
import { PageProject } from "app/services/models/page-project";

@Injectable()
export class DataService<T> extends BaseAuthService {

    private data: ServerResponse<T>;
    public dataUpdated = new EventEmitter<PagedData<T>>();

    constructor(public publicService: PublicService, private httpClient: HttpClient) {
        super(publicService);
    }
 
    public getData(method: string, filter: string, filterUserId: string, filterCapId: string, filterDateFrom, filterDateTo, filterDateContractEnd,
        limit: number, offset: number, dir: string, orderCol: string, ignoreCurrentUser: boolean, isActive: string, isPlanificable: string, isOcult: string, businessUnit: string, filterProjId: string): Observable<ServerResponse<T>> {
        //console.log("getdata", filterDateContractEnd);
        var url = this.getBasePath() + method + "/";

        let params = new HttpParams()
            .append('filter', filter)
            .append('filterUserId', filterUserId == undefined ? "" : filterUserId)
            .append('filterCapId', filterCapId == undefined ? "" : filterCapId)
            .append('filterProjId', filterProjId == undefined ? "" : filterProjId)
            .append('filterDateFrom', filterDateFrom == undefined ? "" : filterDateFrom)
            .append('filterDateTo', filterDateTo == undefined ? "" : filterDateTo)
            .append('filterDateContractEnd', filterDateContractEnd == undefined ? "" : filterDateContractEnd)
            .append('dir', dir)
            .append('orderCol', orderCol)
            .append('limit', limit.toString())
            .append('offset', offset.toString())
            .append('isActive', isActive)
            .append('isPlanificable', isPlanificable)
            .append('isOcult', isOcult)
            .append('businessUnit', businessUnit)
            .append('ignoreCurrentUser', ignoreCurrentUser ? 'true' : 'false');

        return this.httpClient.get<ServerResponse<T>>(url, { headers: this.getHeaders(), params: params });
    }

    public getResults(method: string, page: PageProject): void {
        if (page.allData) {
            this.getData(method, page.filter, page.filterUserId, page.filterCapId, page.filterDateStartFrom, page.filterDateStartTo, page.filterDateContractEnd, page.totalElements, 0, page.sortDir, page.sortColumn, page.ignoreCurrentUser, page.isActive, page.isPlanificable, page.isOcult, page.businessUnit,  page.filterProjId,)
                .subscribe(
                data => {
                    this.data = data;
                    this.dataUpdated.emit(this.getPagedData(page));
                },
                error => {}
                );
        } else {
            this.getData(method, page.filter, page.filterUserId, page.filterCapId, page.filterDateStartFrom, page.filterDateStartTo, page.filterDateContractEnd, page.size, page.pageNumber * page.size, page.sortDir, page.sortColumn, page.ignoreCurrentUser, page.isActive, page.isPlanificable, page.isOcult, page.businessUnit,  page.filterProjId,)
                .subscribe(
                data => {
                    this.data = data;
                    this.dataUpdated.emit(this.getPagedData(page));
                },
                error => { }
                );
        }
    }

    private getPagedData(page: PageProject): PagedData<T> {

        let pagedData = new PagedData<T>();
        if (this.data != null) {
            page.pageNumber = page.pageNumber;
            page.size = this.data.limit;
            page.totalElements = this.data.totalRows;
            page.totalPages = page.totalElements / page.size;
            pagedData.data = this.data.values;
        }
        pagedData.page = page;
        return pagedData;
    }
    public delete(method: string, id: string) {
        var url = this.getBasePath() + method + "/" + id;
        return this.httpClient.delete(url, { headers: this.getHeaders(), responseType: 'text' });
    }

}



// WEBPACK FOOTER //
// ./src/app/services/data.service.ts